import { motion } from "framer-motion";
import { ArrowRight, TrendingUp, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";

const HERO_BG =
  "https://images.unsplash.com/photo-1684503830683-108f3e0fd03f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwzfHxkYXJrJTIwYWJzdHJhY3QlMjB0ZWNobm9sb2d5JTIwYmFja2dyb3VuZHxlbnwwfHx8fDE3ODE2OTY3OTh8MA&ixlib=rb-4.1.0&q=85";

export default function Hero() {
  return (
    <section id="top" className="relative min-h-screen flex items-center pt-28 pb-20 grain-overlay overflow-hidden" data-testid="hero-section">
      <div className="absolute inset-0 z-0">
        <img src={HERO_BG} alt="" className="w-full h-full object-cover opacity-50" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/75 to-background" />
        <div className="absolute inset-0 bg-gradient-to-r from-background via-transparent to-transparent" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 w-full">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: "easeOut" }}
          className="max-w-3xl"
        >
          <div className="inline-flex items-center gap-2 rounded-full border border-norton-yellow/30 bg-norton-yellow/5 px-4 py-1.5 mb-8">
            <Sparkles className="h-3.5 w-3.5 text-norton-yellow" />
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-norton-yellow">
              Programme Revendeur
            </span>
          </div>

          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-heading font-semibold tracking-tighter leading-[1.02] mb-6">
            Vendez une fois,
            <br />
            <span className="text-norton-yellow">touchez chaque année.</span>
          </h1>

          <p className="text-lg text-zinc-400 leading-relaxed max-w-2xl mb-10">
            Le programme Norton Empower vous permet de développer une activité rentable
            dans la cybersécurité. Générez des ventes une fois, et percevez des
            <span className="text-white font-medium"> revenus passifs sur 4 ans </span>
            grâce aux renouvellements automatiques.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <Button
              asChild
              data-testid="hero-cta-button"
              className="group bg-norton-yellow text-black hover:bg-norton-yellow-hover rounded-full text-base font-semibold px-8 h-14 glow-yellow"
            >
              <a href="#simulator">
                Devenir Revendeur
                <ArrowRight className="ml-1 h-5 w-5 transition-transform group-hover:translate-x-1" />
              </a>
            </Button>
            <Button
              asChild
              variant="outline"
              data-testid="hero-secondary-button"
              className="rounded-full text-base font-semibold px-8 h-14 border-white/15 bg-white/5 text-white hover:bg-white/10 hover:text-white"
            >
              <a href="#simulator">
                <TrendingUp className="mr-1 h-5 w-5 text-norton-yellow" />
                Calculer mes revenus
              </a>
            </Button>
          </div>

          <div className="grid grid-cols-3 gap-6 mt-16 max-w-xl">
            {[
              { v: "25%", l: "de remise sur renouvellements" },
              { v: "4 ans", l: "de revenus récurrents" },
              { v: "100%", l: "automatisé par Norton" },
            ].map((s) => (
              <div key={s.l} className="border-l border-white/10 pl-4">
                <div className="text-3xl font-heading font-bold text-white">{s.v}</div>
                <div className="text-xs text-zinc-500 mt-1 leading-snug">{s.l}</div>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
